import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ObjectDetailsComponent} from './object-details.component';

const routes: Routes = [
  {
    path: '',
    component: ObjectDetailsComponent
  }
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ObjectDetailsRoutingModule {}
